import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import MainScreen from "./components/MainScreen";
import oltreLogo from "./img/OltreLogo.png";
import './App.css';

const App = () => {

    const { loginWithRedirect, logout, user, isAuthenticated} = useAuth0();

    return(
        <div>
            {!isAuthenticated && <div className="top-home-screen">
                <div className="opti-your">Optimize your</div>
                <div className="port-today">portfolio today</div>
                <div className="port-growth-box"></div>
                <div className="app-description">
                    The software offers a simple easy to use tool to help you manage your
                    desired lifestyle and estate goals.
                </div>
                <div className="growth-box-words">Portfolio Growth</div>
                <div className="num-growth">16.2k</div>
                <div className="tax-savings-box"></div>
                <img className="oltre-logo-home" src={oltreLogo} />
                <div className="graph-rect1"></div>
                <div className="graph-rect2"></div>
                <div className="graph-rect3"></div>
                <div className="graph-rect4"></div>
                <div className="num12k">12k</div>
                <div className="num14k">14k</div>
                <div className="num16k">16k</div>
                <div className="num18k">18k</div>
                <div className="bar-g1"></div>
                <div className="bar-g2"></div>
                <div className="bar-g3"></div>
                <div className="bar-g4"></div>
                <div className="bar-g5"></div>
                <div className="bar-g6"></div>
                <div className="bar-g7"></div>
                <div className="bar-g8"></div>
                <div className="bar-g9"></div>
                <div className="tax-savings-box-gray"></div>
                <div className="tax-sav-text">98k</div>
                <div className="tax-sav-words">Tax savings</div>
                <div className="rect-2713"></div>
                <div className="rect-2712"></div>
                <button className="login-home-screen login-font" onClick={loginWithRedirect}>Login</button>
            </div>}
            {isAuthenticated && <MainScreen />}
        </div>
        
    )
}

export default App;